/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getQuests = 'searchContent';

export const useGetSearchContent = (token: string) => {
    return useQuery([getQuests, token], () => coreService.searchApi.getSearchContent(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};
